module.exports = __webpack_public_path__ + "img/chevron-left.4d46c9bc.svg";